module.exports = __webpack_public_path__ + "img/szjc6.f76c793e.png";